import {Box, Button, Divider, Image, Paper, Typography} from '@logistics-frontend/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'
import {tag2url} from '@logistics-frontend/utils'
import {forwardRef} from 'react'

import type {AddressPin} from '../../../../../../api/address'
import {OrderNumIcon} from '../OrderNumIcon/OrderNumIcon'
import * as styles from './RouteInfo.classes'

/** Пропсы компонента RouteInfo */
type AddressInfoProps = {
  /** Маршрут */
  route: AddressPin[]
  /** Коллбэк на закрытие модалки */
  onClose: VoidFunction
}

/** Тег иконки адреса "Откуда" */
const ADDRESS_SOURCE_ICON = 'delivery_address_source'

/**
 * Компонент с текущим отмеченным адресом и кнопкой сохранения.
 */
export const RouteInfo = forwardRef(function RouteInfo({route, onClose}: AddressInfoProps, ref) {
  const i18n = useI18n()

  return (
    <Paper ref={ref} flexDirection="column" float="bottom">
      <Paper item="header" px="m" py="l">
        <Typography thickness="medium" variant="body1">
          {i18n('bdui.route.title', 'Маршрут')}
        </Typography>
      </Paper>
      <Divider />
      {route.map((address, index) => {
        const isSource = index === 0

        return (
          <Box>
            {isSource ? (
              <Image className={styles.image} height={56} src={tag2url(ADDRESS_SOURCE_ICON)} />
            ) : (
              <div className={styles.image}>
                <OrderNumIcon color="gray" num={index} />
              </div>
            )}
            <Box flexDirection="column" justifyContent="center">
              <Typography color="minor" variant="caption1">
                {isSource ? i18n('bdui.address.input.from', 'Откуда') : i18n('bdui.address.input.to', 'Куда')}
              </Typography>
              <Typography className={styles.truncatedText} variant="body2">
                {address.title}
              </Typography>
            </Box>
          </Box>
        )
      })}
      <Paper className={styles.footer} item="footer" pb="s" px="s">
        <Button onPress={onClose} size="l" variant="action">
          {i18n('bdui.route.ready', 'Готово')}
        </Button>
      </Paper>
    </Paper>
  )
})
